(function () {
    'use strict';

    angular.module('reportModule', [])
        .controller('reportController', ['$rootScope', '$scope', '$stateParams', 'canvasService', 'helpers', reportController]);

    function reportController($rootScope, $scope, $stateParams, canvasService, helpers) {
        $scope.translate = $rootScope.translate;
        const journeyId = $stateParams.canvasId;

        if (journeyId && $rootScope.jbToken) {
            canvasService
                .getJourney(journeyId)
                .then((result) => {
                    const data = result.data;
                    const title = data.JourneyTitle;
                    const activeDays = helpers.getDayDiff(data.ActivatedDate, data.LastEditOn);

                    $scope.$emit('jbLoader', false);
                    $rootScope.$emit('summary', true, journeyId, title, null, activeDays, true);
                })
                .catch((error) => console.log(error))
        }
    }
})();



// WEBPACK FOOTER //
// ./app/controllers/reportController.js